<template>
    <div class="kt-portlet">
        <div class="kt-portlet__body">
            <h6>{{ $t('dashboard.label.last_login') }}</h6>
            <table class="table table-striped login-tbl">
                <thead>
                <tr>
                    <td style="width:20px">#</td>
                    <td class="text-center">{{ $t('label.country_flag') }}</td>
                    <td>{{ $t('label.ip') }}</td>
                    <td>{{ $t('label.date') }}</td>
                    <td>{{ $t('label.time') }}</td>
                    <td>{{ $t('label.browser') }}</td>
                    <td>{{ $t('label.os') }}</td>
                </tr>
                </thead>
                <tbody>
                <tr
                        class="login-record"
                        v-for="(data, index) in login_log"
                        v-bind:key="index"
                >
                    <td>{{ index + 1 }}</td>
                    <td v-if="data.country_code != null"
                        class="text-center"
                    >
                        <country-flag :country="data.country_code" size="small" />
                    </td>
                    <td v-else class="text-center">-</td>
                    <td>{{ data.ip }}</td>
                    <td>{{ data.date }}</td>
                    <td>{{ data.time }}</td>
                    <td>{{ data.browser }}</td>
                    <td>{{ data.platform }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import CountryFlag from 'vue-country-flag'

    export default {
        name: "login-log",

        props: {
            login_log: {
                default() {
                    return {}
                }
            },
        },

        components: {
            CountryFlag
        }
    }
</script>

<style scoped>
    .login-tbl {
        margin-bottom: 0!important;
    }
    .table td {
        padding: 0.4rem !important;
    }
</style>